import { TFunction } from "i18next";

import { AutocompleteType } from "../../../common/types/autoComplete";
import { EezyCompany } from "../../invoices/invoiceAPI";
import { expertRoles } from "../../user/accessRightChecks";
import { CreateExpertUser } from "../../user/types/commands";
import { ExpertUser } from "../../user/types/entities";

export type ExpertFormValues = {
  firstName: string;
  lastName: string;
  emailAddress: string;
  expertType: string;
  eezyCompanies: EezyCompany[];
  authScopes: AutocompleteType[];
  isAdmin: boolean;
};

export const defaultExpertFormValues: ExpertFormValues = {
  firstName: "",
  lastName: "",
  emailAddress: "",
  expertType: "group",
  eezyCompanies: [],
  authScopes: [],
  isAdmin: false,
};

export const mapFormToCreateExpertPayload = (
  formData: ExpertFormValues,
): CreateExpertUser => ({
  firstName: formData.firstName,
  lastName: formData.lastName,
  emailAddress: formData.emailAddress,
  eezyCompanyIds: formData.eezyCompanies.map((c) => c.eezyCompanyId),
  authScopes: [
    ...formData.authScopes.map((scope: AutocompleteType) => scope.id),
    "e",
  ],
});

export const mapFormToUpdateRolesPayload = (
  formData: ExpertFormValues,
): string[] => formData.authScopes.map((scope) => scope.id);

export const mapExpertToFormValues = (
  expert: ExpertUser,
  eezyCompanyOptions: EezyCompany[],
  t: TFunction,
): ExpertFormValues => {
  const nonExpertScopes = expert.account.authScopes.filter((v) => v !== "e");
  const authScopes = nonExpertScopes.map((v: string) => ({
    id: v,
    name: t(`settings:${expertRoles.find((r) => r.id === v)?.name}`) || "",
  }));

  const isFranchise = expert.account.eezyCompanyIds?.some(
    (id) => eezyCompanyOptions.find((c) => c.eezyCompanyId === id)?.isFranchise,
  );
  const expertCompanies =
    expert.account.eezyCompanyIds
      ?.map((id) => eezyCompanyOptions.find((c) => c.eezyCompanyId === id))
      .filter((c): c is EezyCompany => c !== undefined) ?? [];

  return {
    firstName: expert.account.firstName,
    lastName: expert.account.lastName,
    emailAddress: expert.account.emailAddress,
    eezyCompanies: expertCompanies,
    expertType: isFranchise ? "franchise" : "group",
    authScopes,
    isAdmin: expert.account.authScopes.includes("a"),
  };
};
